<template>
  <div :class="wrapperCls" class="app-wrapper" v-if="isRouterAlive">
    <Sidebar class="sidebar-container" />
    <div class="main-container">
      <Topbar ref="topbar" />
      <PageMain />
    </div>
  </div>
</template>

<script>
import PageMain from "./PageMain.vue"
import Sidebar from "./Sidebar.vue"
import Topbar from "./Topbar.vue"
export default {
  name: "Layout",
  components: {
    PageMain,
    Sidebar,
    Topbar,
  },
  data() {
    return {
      device: "desktop",
      isRouterAlive: true,
    }
  },

  computed: {
    wrapperCls() {
      return {
        hideSidebar: !this.$store.state.app.sidebar.opened,
        openSidebar: this.$store.state.app.sidebar.opened,
        withoutAnimation: this.$store.state.app.sidebar.withoutAnimation,
        mobile: this.$store.state.app.device === "mobile",
      }
    },
  },

  created() {
    let winWidth = document.documentElement.clientWidth
    //console.log(winWidth);
    if (winWidth <= 768) {
      this.$store.dispatch("app/toggleDevice", "mobile")
      this.$store.dispatch("app/closeSideBar", false)
    } else {
      this.$store.dispatch("app/toggleDevice", "desktop")
    }
    this.device = this.$store.state.app.device
    //console.log(this.$store.state.app.device);
  },
  mounted() {
    this.getStat()
  },

  provide() {
    return {
      reload: this.reload,
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  background-color: #f4eff0;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}
</style>
